<template>
  <div v-if="currentArtifact" class="property-contents-container d-flex flex-column flex-grow-1">
    <v-card class="property-tab d-flex flex-column">
      <v-card
        variant="flat"
        style="padding-bottom: 20px; padding-left: 20px; padding-right: 20px"
        :style="{ backgroundColor: artifactRgbColor }"
        :class="{ 'text-white': isDarkBackground }"
      >
        <div class="property-title"> {{ labels.ARTIFACT_PROPERTIES.ARTIFACT_NAME }} </div>
        <div class="artifact-name"> {{ artifactName }} </div>
      </v-card>
      <div v-if="currentArtifact.attributes.length > 0" class="property-title">
        {{ labels.ARTIFACT_PROPERTIES.ATTRIBUTES }}
      </div>
      <v-list v-if="currentArtifact.attributes.length > 0" density="compact" class="prio-item-list">
        <v-list-item
          v-for="t in currentArtifact.attributes"
          :key="t.id"
          density="compact"
          class="prio-item"
        >
          <v-list-item-title>
            {{ t.value }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ t.name }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
  <div
    v-else-if="currentArtifactType"
    class="property-contents-container d-flex flex-column flex-grow-1"
  >
    <v-card class="property-tab d-flex flex-column">
      <div class="property-title"> {{ labels.ARTIFACT_PROPERTIES.ARTIFACT_TYPE_NAME }} </div>
      <v-text-field
        v-model="artifactTypeName"
        hide-details
        single-line
        variant="solo"
        density="compact"
        readonly
        class="flex-grow-0"
      />
      <div class="property-title"> {{ labels.ARTIFACT_PROPERTIES.ARTIFACT_TYPE_PROVIDER }} </div>
      <v-text-field
        v-model="artifactTypeProvider"
        hide-details
        single-line
        variant="solo"
        density="compact"
        readonly
        class="flex-grow-0"
      />
    </v-card>
  </div>
</template>

<script lang="ts" setup>
  import { Artifact, ArtifactType } from '@/models'
  import { computed, PropType } from 'vue'
  import labels from '@/translations/labels.json'

  const props = defineProps({
    currentArtifact: { type: Object as PropType<Artifact>, required: false, default: undefined },
    currentArtifactType: {
      type: Object as PropType<ArtifactType>,
      required: false,
      default: undefined,
    },
  })

  const artifactName = computed(() => {
    return props.currentArtifact ? props.currentArtifact.name : ''
  })

  const artifactTypeName = computed(() => {
    return props.currentArtifactType ? props.currentArtifactType.name : ''
  })

  const getColorParts = () => {
    const color = props.currentArtifact?.artifactType?.color || ''
    return color ? color.split(':').map(Number) : null
  }

  const artifactRgbColor = computed(() => {
    const colorParts = getColorParts()
    return colorParts ? `rgb(${colorParts.join(', ')})` : ''
  })

  const isDarkBackground = computed(() => {
    const colorParts = getColorParts()
    if (!colorParts) return false
    const [r, g, b] = colorParts
    const brightness = (r * 299 + g * 587 + b * 114) / 1000
    return brightness < 128
  })

  const artifactTypeProvider = computed(() => {
    return props.currentArtifactType ? props.currentArtifactType.provider : ''
  })
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_variables.scss';
  .artifact-name {
    font-size: variables.$font-size-name;
    flex-grow: 0;
  }
</style>

<style src="./../SearchView.scss" lang="scss" scoped />
